import { render, staticRenderFns } from "./BackgroundAndTextColorInput.vue?vue&type=template&id=fa316f76&"
import script from "./BackgroundAndTextColorInput.vue?vue&type=script&lang=js&"
export * from "./BackgroundAndTextColorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports